import config from '../config/env';

const DEFAULT_EVENT_IMAGE =
  'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=800&q=80';

/**
 * Normalize image/media URLs for browser display.
 * In dev, uses same-origin /uploads paths (via Vite proxy).
 * In production, serves uploads from the API host (api.nikovibe.com).
 */
export function resolveMediaUrl(url) {
  if (!url) return '';

  if (url.startsWith('data:') || url.startsWith('blob:')) {
    return url;
  }

  const apiBase = (config.apiUrl || 'http://localhost:5000').replace(/\/$/, '');

  if (/^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?(\/uploads\/.*)$/i.test(url)) {
    const uploadsPath = url.replace(/^https?:\/\/[^/]+/i, '');
    return config.isProduction ? `${apiBase}${uploadsPath}` : uploadsPath;
  }

  let uploadsPath = null;
  if (url.startsWith('/uploads/')) {
    uploadsPath = url;
  } else if (url.startsWith(`${apiBase}/uploads/`)) {
    uploadsPath = url.slice(apiBase.length);
  } else {
    const uploadsMatch = url.match(/^https?:\/\/[^/]+(\/uploads\/.*)$/i);
    if (uploadsMatch) {
      uploadsPath = uploadsMatch[1];
    }
  }

  if (uploadsPath) {
    return config.isProduction ? `${apiBase}${uploadsPath}` : uploadsPath;
  }

  return url;
}

export function getEventImageUrl(url) {
  return resolveMediaUrl(url) || DEFAULT_EVENT_IMAGE;
}

export { DEFAULT_EVENT_IMAGE };
